import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Trash, Camera } from "@phosphor-icons/react";

const toB64 = (f) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(f); });

export const RosterList = ({ people, onChange }) => {
  if (!people.length) return null;
  const addPhoto = async (p, file) => {
    if (!file) return;
    try { await api.post(`/people/${p.id}/images/add`, { image_b64: await toB64(file) }); toast.success(`Photo added for ${p.name}`); onChange(); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  const remove = async (p) => {
    if (!window.confirm(`Delete ${p.name} from the roster?`)) return;
    try { await api.delete(`/people/${p.id}`); toast.success(`${p.name} deleted`); onChange(); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  return (
    <div data-testid="roster-list" className="mb-3 border border-white/10 bg-[#121214]">
      <div className="px-3 py-2 border-b border-white/10 font-mono-data text-[11px] text-[#A1A1AA]">
        Staff roster — no photo yet ({people.length}). Add a photo per person, or use Bulk Enroll with files named after each person (e.g. <span className="text-white">Roger.jpg</span>).
      </div>
      {people.map((p) => (
        <div key={p.id} data-testid={`roster-row-${p.id}`} className="flex items-center gap-3 px-3 py-1.5 border-b border-white/5 last:border-0 text-xs">
          <span className="font-bold text-white w-40 truncate" data-testid={`roster-name-${p.id}`}>{p.name}</span>
          <span className="text-[#71717A] font-mono-data flex-1 truncate">{p.department || "—"}</span>
          <label data-testid={`roster-add-photo-${p.id}`} className="cursor-pointer text-[#0A84FF] hover:text-white flex items-center gap-1 font-mono-data">
            <Camera size={13} weight="bold" /> Add photo
            <input type="file" accept="image/*" className="hidden" onChange={(e) => addPhoto(p, e.target.files?.[0])} />
          </label>
          <button data-testid={`roster-delete-${p.id}`} onClick={() => remove(p)} className="text-[#FF453A] hover:text-white flex items-center gap-1 font-mono-data">
            <Trash size={13} weight="bold" /> Delete
          </button>
        </div>
      ))}
    </div>
  );
};
